import React from "react";
import NextPage from "./NextPage";

function NextPageContent({ ...restProps }) {
  return (
    <NextPage to="/map" text="Step into the unseen realms..." {...restProps}>
      EXPLORE THE MAP
    </NextPage>
  );
}

export default NextPageContent;
